export default __webpack_public_path__ + "static/media/pencil.1b069e16.svg";